export enum JobShortlistState {
    Private = 0,
    Draft = 1,
    Published = 2
}